import { render, staticRenderFns } from "./JFilePop.vue?vue&type=template&id=f9e22f1e&scoped=true"
import script from "./JFilePop.vue?vue&type=script&lang=js"
export * from "./JFilePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e22f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9e22f1e')) {
      api.createRecord('f9e22f1e', component.options)
    } else {
      api.reload('f9e22f1e', component.options)
    }
    module.hot.accept("./JFilePop.vue?vue&type=template&id=f9e22f1e&scoped=true", function () {
      api.rerender('f9e22f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/minipop/JFilePop.vue"
export default component.exports